import React from "react"

export default class Topbar extends React.Component {
  render() {
    return (
      <div className="thr-header">
          <img className="logo" src="https://s3-us-west-2.amazonaws.com/com.thinkhr/public/assets/brand/thinkhr-trans-200.png" />
          <span className="tag-line">Developer&#39;s Hub</span>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/plugins/thinkhr/topbar.jsx